import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import FeatherIcon from "feather-icons-react";
import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from "../../../../services/apiResponse"
import Penilaian360Bloc from "../Blocs/Penilaian360Bloc"
import moment from "moment"
import 'moment/locale/id'

import {
    Container,
    Row, Col,
    CardBody, Card, CardHeader, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Spinner
} from "reactstrap"

class Penilaian360Component extends Component {

    penilaianBloc = new Penilaian360Bloc();

    constructor(props) {
        super(props);
        this.state = {
            loadingContent: false,
            total_question: 0,
            complete_question: 0,
            status_counts: null,
            period: null
        }
    }

    loadData = async () => {
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        const employee_uuid = userdata.employee_uuid
        await this.penilaianBloc.fetchDashboard({ employee_uuid : employee_uuid})
    }

    componentDidMount() {

        this.loadData()

        this.penilaianBloc.dashboardChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingContent: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingContent: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        total_question: response.total_question,
                        complete_question: response.complete_question,
                        status_counts: response.status_counts,
                        period: response.period,
                        loadingContent: false,
                    })
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loadingContent: false
                    })
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount(){
        this.penilaianBloc.dashboardChannel.unsubscribe()
    }

    handlePenialian = () => {
        const period_uuid = this.state.period?.ms360_period_uuid
        const role_id = localStorage.getItem("currentRoleId")
        if(parseInt(role_id) === 1){
            // admin
            window.location.href = `/kepegawaian/rekap360.html`
        }else if(parseInt(role_id) === 2){
            // pegawai
            window.location.href = `/kepegawaian/penialian360.html`
        }
    }

    render() {
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        const role_id = localStorage.getItem("currentRoleId");
        return (
           <>
               { this.state.loadingContent ? <>
                {/* <div className='card mb-2'>
                    <div className='card-body p-5 text-center'>
                        <Spinner size="sm" className="me-1" />
                        Memuat Data...
                    </div>
                </div> */}
               </> : <>
                    { this.state.period !== undefined && this.state.period !== null && [1,2].includes(parseInt(role_id)) ? <>
                         <Container fluid>
                             <Row className="g-3">
                                 <Col xs="12">
                                    <div className="mb-3 card p-4">
                                        <div className='clearfix'>
                                            <div className='float-start'>
                                                <CardTitle className="h4 mb-1">Rekap Penilaian 360°</CardTitle>
                                                <CardSubtitle className="text-muted mb-0">
                                                <p className="text-muted mt-2">
                                                    ({`Periode : ${moment(this.state.period?.ms360_period_date_start).format('DD MMMM YYYY')} s/d ${moment(this.state.period?.ms360_period_date_end).format('DD MMMM YYYY')}`})
                                                </p>
                                                Pantau progres dan hasil penilaian kompetensi pegawai berdasarkan penilaian dari berbagai pihak.
                                                </CardSubtitle>
                                            </div>
                                            <div className='float-end'>
                                                <Button type="button" onClick={this.handlePenialian} className="pn-btn-outline btn-info">
                                                    <FeatherIcon icon="search" size="16" />
                                                    <span className="ms-2">Lihat Selengkapnya</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                 </Col>
                                {/* Total Pegawai */}
                                <Col xl={3} md={6}>
                                    <div className="p360-stat-card">
                                    <div>
                                        <div className="p360-stat-label">Total penilai:</div>
                                        <div className="p360-stat-value">
                                        {this.state.status_counts?.semua}
                                        <span className="p360-stat-unit">Pegawai</span>
                                        </div>
                                    </div>
                                    <div className="p360-stat-icon-wrapper blue">
                                        <i className="uil uil-users-alt"></i>
                                    </div>
                                    </div>
                                </Col>

                                {/* Sudah Dinilai */}
                                <Col xl={3} md={6}>
                                    <div className="p360-stat-card">
                                    <div>
                                        <div className="p360-stat-label">Sudah melakukan penilaian:</div>
                                        <div className="p360-stat-value">
                                         {this.state.status_counts?.sudah}
                                        <span className="p360-stat-unit">Pegawai</span>
                                        </div>
                                    </div>
                                    <div className="p360-stat-icon-wrapper green">
                                        <i className="uil uil-check-circle"></i>
                                    </div>
                                    </div>
                                </Col>

                                {/* Belum Dinilai */}
                                <Col xl={3} md={6}>
                                    <div className="p360-stat-card">
                                    <div>
                                        <div className="p360-stat-label">Belum melakukan penilaian:</div>
                                        <div className="p360-stat-value">
                                         {this.state.status_counts?.belum}
                                        <span className="p360-stat-unit">Pegawai</span>
                                        </div>
                                    </div>
                                    <div className="p360-stat-icon-wrapper orange">
                                        <i className="uil uil-clock"></i>
                                    </div>
                                    </div>
                                </Col>

                                {/* Evaluasi Selesai */}
                                <Col xl={3} md={6}>
                                    <div className="p360-stat-card">
                                    <div>
                                        <div className="p360-stat-label">Persentase Progress</div>
                                        <div className="p360-stat-value">
                                            {parseFloat(this.state.status_counts.percentage ?? 0).toFixed(2)}
                                            <span className="p360-stat-unit">%</span>
                                        </div>  
                                    </div>
                                    <div className="p360-stat-icon-wrapper purple">
                                        <i className="uil uil-chart-pie"></i>
                                    </div>
                                    </div>
                                </Col>
                            </Row>
                         </Container>
                    </> : <></> }
               </>  }
           </>
        )
    }

}

export default Penilaian360Component;